import React, { Component } from 'react';
import { connect } from "react-redux";
import _ from 'lodash';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { TextField } from 'rmwc/TextField';
import { Select } from 'rmwc/Select';
import * as PlumbersState from '../plumbers';

import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete'

const initialState = {
            address: '',
            homeownerAddress: ' ',
            stateCode: 'State',
            countryCode: 'Country',
            pageView: 'initial',
            zipError: 'noError'
};

export class Home extends Component {

 constructor(props) {
        super(props)
        this.state = initialState;
    
     this.onChange = this.handleOnChange.bind(this);   
     this.handlePageViewRefer = this.handlePageViewRefer.bind(this);
     this.handlePageViewConsultation = this.handlePageViewConsultation.bind(this);
  
     this.handleChange = this.handleChange.bind(this);

     this.onChange = (address) => this.setState({ address }); 
   
  }

    reset = () => {
        this.setState(initialState);
    }



 handleChange(event) {
    this.setState({homeownerAddress: event.target.value});
    let addressLength = this.state.address.length 
    if (addressLength > 4) {
       geocodeByAddress(this.state.address)
      .then(results => getLatLng(results[0]))
      .then(latLng => console.log('Success', latLng))
      .catch(error => console.error('Error', error))  
    }
  }


handleOnChange(event) {
  this.setState({
    address: event.target.value
  })
  console.log(this.state.address)
}




  handleSubmit = (event) => {
        let countryCode = this.state.countryCode
        let stateCode = this.state.stateCode
      if (countryCode == "Country") {
        event.preventDefault()
        this.setState({
          selectColorCountry: {color: 'red'}
        })
      }
      if (stateCode == "State") {
        event.preventDefault()
        this.setState({
          selectColorState: {color: 'red'}
        })
      }
  }


    handleFormSubmit = (event) => {
      event.preventDefault()

      this.setState({
          pageView: 'searched'
        })

      geocodeByAddress(this.state.address)
        .then(results => getLatLng(results[0]))
          .then(({ lat, lng }) => 
              this.props.dispatch(PlumbersState.setLatLng(lat, lng))
            ).then(({ lat, lng }) => 
              this.props.dispatch(PlumbersState.getPlumberDynamic())
            )
        .catch(error => console.error('Error', error)
      )
      
    }

handleEnter = (address) => {
   this.setState({
          pageView: 'searched'
        })
       geocodeByAddress(this.state.address)
        .then(results => getLatLng(results[0]))
          .then(({ lat, lng }) => 
              this.props.dispatch(PlumbersState.setLatLng(lat, lng))
            ).then(({ lat, lng }) => 
              this.props.dispatch(PlumbersState.getPlumberDynamic())
            )
        .catch(error => console.error('Error', error)
      )}



handlePageViewRefer =  (event) => {
event.preventDefault()
   this.setState({
          pageView: 'refer'
        })
  console.log('pageview')
  console.log(this.state)
  console.log(this.props) 
}

handlePageViewConsultation = (event) => {
  event.preventDefault()
  this.setState({
    pageView: 'consultation'
  })
}

renderReferPage = () => {


  let sf_endpoint = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
  let test_sf_endpoint = "https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"

  let sf_org_id = "00D1I00000041di"
  let test_sf_org_id = "00DZ000000NDw77"




  return (
    <div>

    <div className="home-get-phyn-header-page">Refer a plumber</div>
    <div className="home-get-phyn-body-page">Already have a plumber that you want to have install Phyn Plus for you? Send us their information and we'll make sure that they get all the training they need to get you up and running.</div>
    <div className="contact-form">
    <form  action={sf_endpoint} method="POST" autocomplete="off">
   
    <div className="refer-sub-header">Your Information</div>
    <TextField className="firstName" name="first_name" label="First Name"   required={true} />
    <TextField className="lastName" name="last_name" label="Last Name" required={true}  />
   <TextField type="email" className="email" name="email" label="Email" required={true} />
   

       
    <div className="refer-sub-header ref-two">Your Plumber’s Information</div>
     <TextField className="plumberName" name="00N1I00000MS2S7" label="Name" required={true} />
     <TextField type="number"  className="plumberPhone" name="00N1I00000MS2SC" label="Phone"  />
      <TextField type="email" className="plumberEmail" name="00N1I00000MS2SH" label="Email" />
 <input type="hidden" name="oid" value={sf_org_id} />
 <input type="hidden" name="retURL" value="https://www.phyn.com/get-phyn-submitted" />
<input type="hidden" id="lead_group" name="00N1I00000MSV81"  value="Customer_With_Plumber" />

 <input className="submit" type="submit" value="Submit" />


    </form>
    </div>
    </div>
    )
}

renderPlumber = (plumber) => {
let plumberEmail = plumber.email
let plumberPhone = plumber.phone
let plumberCompany = plumber.name
let plumberStreet = plumber.shippingStreet
let plumberCity = plumber.shippingCity
let plumberZip = plumber.shippingPostalCode
let plumberState = plumber.shippingStateCode

let plumberFullAddress = plumberStreet + ", " + plumberCity + ", " + plumberState + " " + plumberZip

return (
    
      <div>
      <div className="plumberContainer">
      <div className="plumberCompany">
      {plumberCompany}
      </div>
      <div className="plumberPhone">
      {plumberPhone}
      </div>
      <div className="plumberEmail">
      {plumberEmail}
      </div>
      <div className="plumberFullAddress">
      {plumberFullAddress}
      </div>
      </div>
      </div>
    
  )

}



renderPageOfPlumbers = () => {
  const plumbers = _.filter(this.props.plumbers)
  const plumberMessages = plumbers.map(this.renderPlumber)

  const numPlumbers = this.props.plumberCount

  let plumberLang 

  if (numPlumbers == 1) {
    plumberLang = "installer"
  }

  else {
    plumberLang = "installers"
  }

  return (
   <div>
     <div className="home-get-phyn-header-sub-page">We have located {numPlumbers} {plumberLang} in your area.</div>
    {plumberMessages}
    
       <form className="consultationForm" onSubmit={this.handlePageViewConsultation}>
   <div className="home-get-phyn-consultation">Still have questions about Phyn Plus, or want to make sure it's right for your home?   <input className="consultationBtn"  type="submit" value="Get a consultation from a Pro Squad installer." /></div>

             
          </form>
   </div>
    )
}

  renderInstallerButton = () => {



    let address = this.state.address
    let addressLength = this.state.address.length
    let inputProps
  
    console.log(addressLength)

    if (addressLength = '0') {
        inputProps = { 
          onChange: this.onChange,
          
          value: this.state.address,
        
          shouldFetchSuggestions: false,
          placeholder: 'Zip Code',
        }

    
      }
      else  {
             inputProps = {
              onChange: this.onChange,
              value: this.state.address,
           
              shouldFetchSuggestions: false,
              placeholder: 'Zip Code',
            }
      }

      const isEnabled = address.length > 0
      console.log('Address Length')
      console.log(address.length)


 const options = {
      types: ['postal_code']
    }
const onError = (status) => {
    this.setState({
    zipError: status
  })
  console.log('Google Maps API returned error with status: ', status)
  console.log(this.state.zipError)
 
}

    return (
      <div>
           <div className="header-find-installer">Find an installer</div>
          
          
            <div className="home-get-phyn-body-page"> 
              Enter your zip code to find Uponor Pro Squad installers in your area.
            </div>
           
           
            <form className="find-installer-start" onSubmit={this.handleFormSubmit}>
              <PlacesAutocomplete 
                inputProps={inputProps}
                onSelect={this.handleSelect}
                options={options}
                onError={onError}
                onEnterKeyDown={this.handleEnter}
             
            >

            </PlacesAutocomplete>
            
            <input className="find-installer" type="submit" disabled = {!isEnabled} value="Find an installer"  />
            </form>
              
           


        </div>
      )
    }


  renderFormWithPlumbers = () => {



 
  let sf_endpoint = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
  let test_sf_endpoint = "https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"

  let sf_org_id = "00D400000008yNy"
  let test_sf_org_id = "00D2a0000000RW4"

  
  const numPlumbers = this.props.plumberCount

  let plumberLang 

  if (numPlumbers == 1) {
    plumberLang = "installer"
  }

  else {
    plumberLang = "installers"
  }

  let plumbers = this.props.plumbers

  plumbers = JSON.stringify(plumbers)


  const style = {display: 'none'};
  
      
    return (
      <div>
       
        <div className="home-get-phyn-header-sub-page">Find out if Phyn is right for your home</div>

        <div className="home-get-phyn-body-page">
      Enter your info below and a member of the Uponor Pro Squad will reach out to answer any questions you have about Phyn Plus.
          </div>

     
            <div className="contact-form">
              <form action={sf_endpoint} method="post">
              <input type="hidden" name="oid" value={sf_org_id} />


                   <TextField className="firstName" name="first_name" label="First Name"   required={true} />
    <TextField className="lastName" name="last_name" label="Last Name" required={true}  />
      <TextField className="address" name="street" label="Address" required={true}  />
        <TextField className="city" name="city" label="City" required={true}  />

              

               
  <Select
    label="State"
  defaultValue=""
    name="state_code"
    className="state"
    required={true}
  
       > 

               <option value="" disabled></option>
  <option value="AL">Alabama</option>
  <option value="AK">Alaska</option>
  <option value="AZ">Arizona</option>
  <option value="AR">Arkansas</option>
  <option value="CA">California</option>
  <option value="CO">Colorado</option>
  <option value="CT">Connecticut</option>
  <option value="DE">Delaware</option>
  <option value="DC">District Of Columbia</option>
  <option value="FL">Florida</option>
  <option value="GA">Georgia</option>
  <option value="HI">Hawaii</option>
  <option value="ID">Idaho</option>
  <option value="IL">Illinois</option>
  <option value="IN">Indiana</option>
  <option value="IA">Iowa</option>
  <option value="KS">Kansas</option>
  <option value="KY">Kentucky</option>
  <option value="LA">Louisiana</option>
  <option value="ME">Maine</option>
  <option value="MD">Maryland</option>
  <option value="MA">Massachusetts</option>
  <option value="MI">Michigan</option>
  <option value="MN">Minnesota</option>
  <option value="MS">Mississippi</option>
  <option value="MO">Missouri</option>
  <option value="MT">Montana</option>
  <option value="NE">Nebraska</option>
  <option value="NV">Nevada</option>
  <option value="NH">New Hampshire</option>
  <option value="NJ">New Jersey</option>
  <option value="NM">New Mexico</option>
  <option value="NY">New York</option>
  <option value="NC">North Carolina</option>
  <option value="ND">North Dakota</option>
  <option value="OH">Ohio</option>
  <option value="OK">Oklahoma</option>
  <option value="OR">Oregon</option>
  <option value="PA">Pennsylvania</option>
  <option value="RI">Rhode Island</option>
  <option value="SC">South Carolina</option>
  <option value="SD">South Dakota</option>
  <option value="TN">Tennessee</option>
  <option value="TX">Texas</option>
  <option value="UT">Utah</option>
  <option value="VT">Vermont</option>
  <option value="VA">Virginia</option>
  <option value="WA">Washington</option>
  <option value="WV">West Virginia</option>
  <option value="WI">Wisconsin</option>
  <option value="WY">Wyoming</option>
    <option value="AB">Alberta</option>
  <option value="BC">British Columbia</option>
  <option value="MB">Manitoba</option>
  <option value="NB">New Brunswick</option>
  <option value="NL">Newfoundland and Labrador</option>
  <option value="NS">Nova Scotia</option>
  <option value="ON">Ontario</option>
  <option value="PE">Prince Edward Island</option>
  <option value="QC">Quebec</option>
  <option value="SK">Saskatchewan</option>
  <option value="NT">Northwest Territories</option>
  <option value="NU">Nunavut</option>
  <option value="YT">Yukon</option>
</Select>
            <Select
    label="Country"
  defaultValue=""
    name="country_code"
    className="country"
    required={true}
  
       > 

               <option value="" disabled></option>
        <option value="US">United States</option>
        <option value="CA">Canada</option>
      </Select>  
  <TextField className="zip" name="zip" label="Zip" required={true}  />
          
                
 
                <TextField type="number" className="phoneNumber" name="phone" label="Phone Number" required={true} />
             
   <TextField  type="email" className="email" name="email" label="Email" required={true} />
              
             

                 <input type="hidden" id="lead_source" name="lead_source" value="Phyn.com" />
                

              
               
                 <input type="hidden" name="retURL" value="https://www.phyn.com/get-phyn-submitted/" />
<input type="hidden" id="lead_group" name="00N1I00000MSV81"  value="Customer" />
                <input className="submit" type="submit" value="Submit" />
            </form>
            </div>
         </div>
      )
  }

  renderFormNoPlumbers = () => {
  let sf_endpoint = "https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"
  let test_sf_endpoint = "https://test.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8"


  let sf_org_id = "00D400000008yNy"
  let test_sf_org_id = "00D2a0000000RW4"

      return (
      <div>
        <div className="home-get-phyn-header-page">Unfortunately, there are no installers in your area </div>
        

        <div className="home-get-phyn-body-page">
       Sign up now, and as soon as we have availability in your city, a Pro Squad member will reach out to schedule an installation. No money down. No commitment. Just let us know you’re interested, and we’ll be in touch.
          </div>

    
            <div className="contact-form">
    <form action={sf_endpoint} method="post">
              <input type="hidden" name="oid" value={sf_org_id} />


                   <TextField className="firstName" name="first_name" label="First Name"   required={true} />
    <TextField className="lastName" name="last_name" label="Last Name" required={true}  />
      <TextField className="address" name="street" label="Address" required={true}  />
        <TextField className="city" name="city" label="City" required={true}  />

              

               
  <Select
    label="State"
  defaultValue=""
    name="state_code"
    className="state"
    required={true}
  
       > 

               <option value="" disabled></option>
  <option value="AL">Alabama</option>
  <option value="AK">Alaska</option>
  <option value="AZ">Arizona</option>
  <option value="AR">Arkansas</option>
  <option value="CA">California</option>
  <option value="CO">Colorado</option>
  <option value="CT">Connecticut</option>
  <option value="DE">Delaware</option>
  <option value="DC">District Of Columbia</option>
  <option value="FL">Florida</option>
  <option value="GA">Georgia</option>
  <option value="HI">Hawaii</option>
  <option value="ID">Idaho</option>
  <option value="IL">Illinois</option>
  <option value="IN">Indiana</option>
  <option value="IA">Iowa</option>
  <option value="KS">Kansas</option>
  <option value="KY">Kentucky</option>
  <option value="LA">Louisiana</option>
  <option value="ME">Maine</option>
  <option value="MD">Maryland</option>
  <option value="MA">Massachusetts</option>
  <option value="MI">Michigan</option>
  <option value="MN">Minnesota</option>
  <option value="MS">Mississippi</option>
  <option value="MO">Missouri</option>
  <option value="MT">Montana</option>
  <option value="NE">Nebraska</option>
  <option value="NV">Nevada</option>
  <option value="NH">New Hampshire</option>
  <option value="NJ">New Jersey</option>
  <option value="NM">New Mexico</option>
  <option value="NY">New York</option>
  <option value="NC">North Carolina</option>
  <option value="ND">North Dakota</option>
  <option value="OH">Ohio</option>
  <option value="OK">Oklahoma</option>
  <option value="OR">Oregon</option>
  <option value="PA">Pennsylvania</option>
  <option value="RI">Rhode Island</option>
  <option value="SC">South Carolina</option>
  <option value="SD">South Dakota</option>
  <option value="TN">Tennessee</option>
  <option value="TX">Texas</option>
  <option value="UT">Utah</option>
  <option value="VT">Vermont</option>
  <option value="VA">Virginia</option>
  <option value="WA">Washington</option>
  <option value="WV">West Virginia</option>
  <option value="WI">Wisconsin</option>
  <option value="WY">Wyoming</option>
    <option value="AB">Alberta</option>
  <option value="BC">British Columbia</option>
  <option value="MB">Manitoba</option>
  <option value="NB">New Brunswick</option>
  <option value="NL">Newfoundland and Labrador</option>
  <option value="NS">Nova Scotia</option>
  <option value="ON">Ontario</option>
  <option value="PE">Prince Edward Island</option>
  <option value="QC">Quebec</option>
  <option value="SK">Saskatchewan</option>
  <option value="NT">Northwest Territories</option>
  <option value="NU">Nunavut</option>
  <option value="YT">Yukon</option>
</Select>
   <Select
    label="Country"
  defaultValue=""
    name="country_code"
    className="country"
  
       > 

               <option value="" disabled></option>
        <option value="US">United States</option>
        <option value="CA">Canada</option>
      </Select>  
  <TextField className="zip" name="zip" label="Zip" required={true}  />
          
                
          
                <TextField type="number" className="phoneNumber" name="phone" label="Phone Number" required={true} />
             
   <TextField className="email" name="email" label="Email" required={true} />
              
             

                 <input type="hidden" id="lead_source" name="lead_source" value="Phyn.com" />
               
              
               
                 <input type="hidden" name="retURL" value="https://www.phyn.com/get-phyn-submitted/" />
<input type="hidden" id="lead_group" name="00N1I00000MSV81"  value="Customer" />
                <input className="submit" type="submit" value="Submit" />
            </form>
            </div>
         </div>
      )
  }





  renderFilter = () => {

    const statusPending = (this.props.status === 'pending')
    const statusMatchesFound = (this.props.status === 'matchesFound')
    const statusNoMatches = (this.props.status === 'noMatches')

    const pageViewInitial = (this.state.pageView === 'initial')
    const pageViewRefer = (this.state.pageView === 'refer')
    const pageViewSearched = (this.state.pageView === 'searched' )
    const pageViewConsultation = (this.state.pageView === 'consultation')

    const pageViewSearchError = (this.state.zipError === 'INVALID_REQUEST')
    



     if (pageViewInitial) {
     return (
        <div>
      
          {this.renderInstallerButton()}
        </div>
      )}

     else if (pageViewRefer) {
      return (
        <div>
              <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
          {this.renderReferPage()}
        </div>
        )
     }

     else if (pageViewConsultation) {
      return (
        <div>
              <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
          {this.renderFormWithPlumbers()}
        </div>
        )
     }

     else if (statusMatchesFound && pageViewSearched) {
      return (
        <div>
            <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
        {this.renderPageOfPlumbers()}
        </div>
        )
     }

      else if (statusMatchesFound && pageViewInitial) {
        return (
          <div>
              <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
          {this.renderFormWithPlumbers()}
          </div>
          )}

      else if (this.props.status === 'noMatches') {
        return (
          <div>
                <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
            {this.renderFormNoPlumbers()}
          </div>
        )}

      else if (pageViewSearchError && statusPending) {
        return (
          <div>
                <div className="searchTop"><a onClick={this.reset}> &#60;  Back To Search </a></div>
            {this.renderFormNoPlumbers()}
          </div>
        )}



      }


  render = () => {


      return (
        <div>
   
           {this.renderFilter()}
         
        </div>
      )
    }
  }

export default connect((store, props) => {  

  let plumbers = store.plumbers
  let status = store.status
  let lat = store.lat
  let lng = store.lng
  let plumberCount = store.plumberCount





  return {
  
    plumbers:  plumbers,
    status: status,
    lat: lat,
    lng: lng,
    plumberCount: plumberCount
  };
})(Home);


// WEBPACK FOOTER //
// ./src/modules/home/home.jsx